import {
  PaymentRecordsData,
} from '@dapi/sdk';
import {
  paymentRecord,
  paymentRecordCheckout,
} from '../dictionaries/index';

export const paymentRecords: PaymentRecordsData = {
  paymentRecords: [paymentRecord]
};

export const paymentRecordsCheckoutMock: PaymentRecordsData = {
  paymentRecords: [paymentRecordCheckout]
};
